require('./bootstrap');

import AirDatepickerDirective from './directives/air-datepicker';
import SwiperPlugin from './plugins/swiper';

import 'bootstrap/dist/css/bootstrap-grid.min.css';
import '../sass/app.scss';
import '../css/tailwind.css';

// import global helpers
import { goTo, updateStore, showGlobalError } from '@/helpers/pqFlow';

import axios from 'axios';
import App from '@/views/app.vue';
import { createApp, watch, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import { router } from '@/routes/router';
import { debounce } from 'lodash';

// Create Vue app first
const app = createApp(App);

// Create and use Pinia before accessing stores
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.config.globalProperties.axios = axios;

// Pinia stores
import { useApplicationStore } from '@/stores/applicationStore';
import { useUserStore } from '@/stores/userStore';
import { useAuthStore } from '@/stores/authStore';
import { useMessageStore } from '@/stores/messageStore';
import { useRedirectStore } from '@/stores/redirectStore';

const applicationStore = useApplicationStore();
const userStore = useUserStore();
const authStore = useAuthStore();
const messageStore = useMessageStore();
const redirectStore = useRedirectStore();

applicationStore.loadFromLocalStorage();
userStore.loadFromLocalStorage();
authStore.loadFromLocalStorage();
messageStore.loadFromLocalStorage();
redirectStore.loadFromLocalStorage();

// Watch for changes and persist them to localStorage
watch(
    () => applicationStore.$state,
    debounce(() => applicationStore.saveToLocalStorage(), 300),
    { deep: true }
);

watch(
    () => userStore.$state,
    debounce(() => userStore.saveToLocalStorage(), 300),
    { deep: true }
);

watch(
    () => authStore.$state,
    debounce(() => authStore.saveToLocalStorage(), 300),
    { deep: true }
);

watch(
    () => messageStore.$state,
    debounce(() => messageStore.saveToLocalStorage(), 300),
    { deep: true }
);

watch(
    () => redirectStore.$state,
    debounce(() => redirectStore.saveToLocalStorage(), 300),
    { deep: true }
);

// register air-datepicker custom directive globally
app.directive('air-datepicker', AirDatepickerDirective);

// global properties
app.config.globalProperties.$goTo = goTo;
app.config.globalProperties.$updateStore = updateStore;
app.config.globalProperties.$showGlobalError = showGlobalError;

// use swiper
app.use(SwiperPlugin);

// global components
app.component(
    'FullHeader',
    defineAsyncComponent(() => import('@/views/partials/full-header.vue'))
);
app.component(
    'FullHeaderAuth',
    defineAsyncComponent(() => import('@/views/partials/full-header-auth.vue'))
);
app.component(
    'ShortHeader',
    defineAsyncComponent(() => import('@/views/partials/short-header.vue'))
);
app.component(
    'ShortHeaderAuth',
    defineAsyncComponent(() => import('@/views/partials/short-header-auth.vue'))
);
app.component(
    'SiteFooter',
    defineAsyncComponent(() => import('@/views/partials/site-footer.vue'))
);
app.component(
    'BackButton',
    defineAsyncComponent(() => import('@/components/BackButton.vue'))
);
app.component(
    'Continue',
    defineAsyncComponent(() => import('@/components/Continue.vue'))
);
app.component(
    'ErrorInfo',
    defineAsyncComponent(() => import('@/components/ErrorInfo.vue'))
);
app.component(
    'SuccessInfo',
    defineAsyncComponent(() => import('@/components/SuccessInfo.vue'))
);
app.component(
    'CustomDropdown',
    defineAsyncComponent(() => import('@/components/CustomDropdown.vue'))
);

app.mount('#app');
